import { getFeature } from 'Cloud/Application/FeaturesEs6';
import {
    ANONYM_USER,
    IS_BIZ_USER,
    IS_MOBILE_BROWSER,
    IS_PAID_USER,
    IS_WEBVIEW,
    IS_WEBVIEW_FROM_UA,
} from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type TariffList = {
    year: string[];
    month: string[];
};

export const beautifulAddressBenefit = 'Красивый адрес для Почты';

const beautifulAddress: 'a' | 'b' = getFeature('beautiful-address-on-landing');

export const beautifulAddressEnabled =
    !IS_BIZ_USER && !IS_PAID_USER && !ANONYM_USER && !IS_MOBILE_BROWSER && !(IS_WEBVIEW || IS_WEBVIEW_FROM_UA) && beautifulAddress === 'b';

export const beautifulAddressTariffList: TariffList = getFeature('beautiful-address-tariff-list') || {
    year: [
        'W256GB_1y_landing_segmentation_pretty_address_discount',
        'W512GB_1y_landing_segmentation_pretty_address_discount',
        'W1TB_1y_landing_segmentation_pretty_address_discount',
        'W2TB_1y_landing_segmentation_pretty_address_discount',
    ],
    month: [
        'W256GB_1m_landing_segmentation_discount',
        'W512GB_1m_landing_segmentation_discount',
        'W1TB_1m_landing_segmentation_discount',
        'W2TB_1m_landing_segmentation_discount',
        'W4TB_1m_landing_segmentation_discount',
    ],
};

registerExperiment('beautiful-address', beautifulAddress, [
    AnalyticEventNames.BEAUTIFUL_ADDRESS_MODAL_SHOW,
    AnalyticEventNames.BEAUTIFUL_ADDRESS_MODAL_CLICK,
    AnalyticEventNames.BEAUTIFUL_ADDRESS_MODAL_CLOSE,
]);
